/**
 * 业务标识选择器组件
 */

import React from 'react';
import { Select } from 'dingtalk-design-desktop';
import type { BusinessKey } from '../types';

interface BusinessKeySelectorProps {
  businessKeys: BusinessKey[];
  selectedBusinessKey: BusinessKey | null;
  onSelect: (businessKey: BusinessKey) => void;
  loading?: boolean;
  disabled?: boolean;
}

export const BusinessKeySelector: React.FC<BusinessKeySelectorProps> = ({
  businessKeys,
  selectedBusinessKey,
  onSelect,
  loading = false,
  disabled = false,
}) => {
  return (
    <div className="business-key-selector">
      <label className="selector-label">
        业务标识（必选）
      </label>
      <Select
        value={selectedBusinessKey?.name}
        onChange={(value) => {
          console.log("🎯 BusinessKeySelector onChange 触发:");
          console.log("  - onChange value:", value);
          console.log("  - value类型:", typeof value);
          console.log("  - businessKeys数组:", businessKeys);
          
          const selected = businessKeys.find((key) => key.name === value);
          console.log("  - 找到的selected:", selected);
          console.log("  - selected类型:", typeof selected);
          
          if (selected) {
            console.log("  - 即将调用onSelect，参数:", selected);
            onSelect(selected);
          } else {
            console.warn("  - ⚠️ 未找到匹配的业务标识");
          }
        }}
        placeholder="请选择业务标识"
        loading={loading}
        disabled={disabled || loading}
        style={{ width: '100%' }}
      >
        {businessKeys.map((key) => (
          <Select.Option key={key.name} value={key.name}>
            <span style={{ fontSize: '14px', fontFamily: 'inherit' }}>{key.name}</span>
            {key.description && (
              <span style={{ color: '#999', fontSize: '14px', fontFamily: 'inherit', marginLeft: '8px' }}>
                ({key.description})
              </span>
            )}
          </Select.Option>
        ))}
      </Select>
    </div>
  );
};
